import { GraphQLExecuteError } from '@data-access/lib/execute'
import type { Query } from '@tanstack/react-query'
import { noticeError } from '@utils/utils-analytics/notice-error'

export const DAY_PRICE_ERROR_REPORT = 'experience-day-prices'

/** QueryCache.onError runs once per failed fetch, after automatic retries exhaust.
 * Observer placeholder data is not confirmed data in this query's cache.
 */
export function reportTerminalDayPriceError(
  error: Error,
  query: Query<unknown, unknown>,
  context: { environment: string; release: string }
): void {
  if (query.meta?.terminalErrorReport !== DAY_PRICE_ERROR_REPORT) return
  if (query.queryKey[0] !== 'nexperienceDayPrices') return

  // Do not send raw backend messages, query variables, URLs, tokens or selections.
  // Native fetch errors still get a stable, actionable operation name.
  const isGraphQL = error instanceof GraphQLExecuteError
  let failureKind = 'network-or-client'
  if (isGraphQL) {
    failureKind = error.status >= 400 ? 'http' : 'graphql'
  }
  noticeError(new Error('Terminal query failure: nexperienceDayPrices'), {
    terminalQueryFailure: DAY_PRICE_ERROR_REPORT,
    operation: 'nexperienceDayPrices',
    loadPhase: query.state.data === undefined ? 'initial-load' : 'background-refresh',
    environment: context.environment,
    release: context.release,
    failureKind,
    ...(isGraphQL ? { httpStatus: error.status } : {}),
  })
}
